import loadBundledProducts from "@NA/Handlers/ADILoadBundledProductsHandler";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { ProductCarouselProductStyles } from "@NA/Overrides/Components/ProductCarouselProduct";
import { getBundledProductsById } from "@NA/Store/Components/BundledProducts/BundledProductsSelector";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { getPageLinkByNodeId, useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { useEmblaCarousel } from "embla-carousel/react";
import { ThemeProps, css, withTheme } from "styled-components";
import translate from "@insite/client-framework/Translate";
import ProductCarouselProductFeatured from "@NA/Components/BundledProducts/ProductCarouselProductFeatured";
import { ProductModel, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import ADIColors from "@NA/Utils/ADIColors";
import ADIProductCarouselProduct from "@NA/Components/ProductDetail/ADIProductCarouselProduct";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import Link from "@insite/mobius/Link";
import { getGaTagforL1L2 } from "@NA/Utils/GtmUtility";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProdcutInfosFromProductList } from "@NA/Store/Selector/ADIProductInfoListSelectors";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const products = getBundledProductsById(state, ownProps.id);

    return {
        products,
        productCount: products?.length ?? 0,
        errorMessage: null,
        isLoadingState: state.ADIGlobalData.bundledProductsStore.isLoading,
        location: getLocation(state),
        session: getSession(state),
        productInfos: getProdcutInfosFromProductList(state, ownProps.id),
    };
};

const mapDispatchToProps = {
    loadBundledProducts,
};

const enum fields {
    title = "title",
    showAll = "showAll",
    showALLURL = "showALLURL",
    categoryName = "categoryName",
    productIds = "productIds",
    stackedOrCarousel = "stackedOrCarousel",
}

interface NameArray {
    name: LinkFieldValue;
    productIds: ProductIdModel[];
}

interface StructuredData {
    name: string;
    productIds: ProductIdModel[];
}

interface TabModel {
    fields: NameArray;
}

interface CategoryArray {
    id: string;
}

interface ProductIdModel {
    fields: CategoryArray;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.showAll]: string;
        [fields.showALLURL]: LinkFieldValue;
        [fields.categoryName]: TabModel[];
        [fields.productIds]: ProductIdModel;
        [fields.stackedOrCarousel]: "Stacked" | "Carousel";
    };
}

export interface FeaturedTopSellersCarouslStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    urlText?: InjectableCss;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    dotsContainerWrapper?: InjectableCss;
    dotButton?: ButtonPresentationProps;
}

export const featuretopSellersCarouselStyles: FeaturedTopSellersCarouslStyles = {
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        variant: "h2",
        css: css`
            text-align: start;
            margin-bottom: 0px;
            font-size: 36px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 26px;
                    `,
                    css`
                        font-size: 26px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    urlText: {
        css: css`
            margin-bottom: 12px;
            > span {
                font-size: 14px;
                font-weight: bold;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: ${getColor("text.main")} !important;
                text-transform: uppercase;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            position: relative;
            margin: auto;
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                        position: absolute;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            min-height: 6px;
            transform: rotate(180deg);
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
            border: 0;
            width: 28px !important;
            height: 28px !important;
            opacity: 1;
            margin-bottom: 0;
            background-size: 28px 28px !important;
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        right: 0%;
                        top: 31%;
                        display: none;
                    `,
                    css`
                        top: 9%;
                        right: 11%;
                    `,
                    css`
                        top: -12%;
                        right: 12%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                        position: absolute;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            min-height: 6px;
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
            border: 0;
            width: 28px !important;
            height: 28px !important;
            opacity: 1;
            margin-bottom: 0;
            background-size: 28px 28px !important;
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        right: 10%;
                        top: 15%;
                        display: none;
                    `,
                    css`
                        top: 30%;
                        right: 5%;
                    `,
                    css`
                        top: 9%;
                        right: 7%;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            flex-basis: 20%;
            max-width: 20%;
            padding: 0 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 33.333%;
                        max-width: 33.333%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0px;
            display: flex;
            flex-direction: column;
            border: 1px solid ${ADIColors.gray7};
            border-radius: 5px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        padding-top: 10px;
                        flex-flow: row;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        padding-top: 10px;
                        flex-flow: row;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    dotsContainerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            margin-top: 26px;
            position: relative;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 93%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    dotButton: {
        css: css`
            min-height: 7px;
            max-width: 55px;
            height: 3px;
            width: 10%;
            padding: 0;
            margin: 0 4px;
            border: 0px;
            border-radius: 2px;
            background: ${getColor("common.border")};
            background-color: ${ADIColors.gray16};
            border: 1px solid ${ADIColors.gray16};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0 0;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            &:hover {
                background: ${ADIColors.white};
            }
            &:active {
                background-color: ${ADIColors.darkBlue1};
                border: 1px solid ${ADIColors.darkBlue1};
            }
            &:focus {
                outline: none;
            }
        `,
    },
};

const styles = featuretopSellersCarouselStyles;

type Props = OwnProps &
    HasShellContext &
    HasCategoryContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

const ADIFeaturedBestSellerCarousal: React.FC<Props> = ({
    fields,
    id,
    shellContext,
    category,
    loadBundledProducts,
    productCount,
    products,
    errorMessage,
    theme,
    isLoadingState,
    location,
    session,
    productInfos,
}) => {
    const afterCarousel = React.createRef<HTMLSpanElement>();
    const [slideProducts, setSildeProduct] = React.useState<ProductModel[]>();
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [filteredFields, setFilteredFields] = useState<StructuredData | undefined>(undefined);
    const links = useGetLinks(fields.categoryName, o => o.fields.name);
    const link = useGetLink(fields.showALLURL);
    const [initLoad, setInitLoad] = React.useState(true);

    useEffect(() => {
        const FilteredData: StructuredData[] = fields.categoryName
            .map((category, index) => {
                if (category.fields.name.type === "Category") {
                    return {
                        name: links[index].url || "",
                        productIds: category.fields.productIds,
                    };
                }
                return undefined;
            })
            .filter(data => {
                if (data !== undefined && data.name === category?.path) {
                    return data;
                }
            }) as StructuredData[];

        if (FilteredData.length) {
            setFilteredFields(FilteredData[0]);
        } else {
            setFilteredFields(undefined);
        }
    }, [category, fields]);

    useEffect(() => {
        const productIds = filteredFields?.productIds
            ?.map(item => item.fields.id)
            .filter(x => x != undefined && x != "");
        if (!isLoadingState) {
            if (productIds?.length !== undefined && productIds?.length > 0) {
                setInitLoad(false);
                loadBundledProducts({
                    id,
                    productNumbers: productIds,
                    widgetName: fields.title,
                    expand:"properties"
                });
            }
        }
    }, [filteredFields?.productIds, location]);

    const [emblaRef, embla] = useEmblaCarousel({ loop: false });
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const [canScrollPrev, setCanScrollPrev] = React.useState(false);
    const [canScrollNext, setCanScrollNext] = React.useState(true);
    const [tracked, setTracked] = React.useState(false);

    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        if (embla) {
            setSelectedIndex(embla.selectedScrollSnap());
        }
    };

    const getSlidesToScroll = React.useCallback(() => {
        const maxNumberOfColumns = 5;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 3;
        } else {
            localSlidesToScroll = 5;
        }

        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, []);

    const [slidesToScroll, setSlidesToScroll] = React.useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = React.useState(getDraggable());

    React.useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [windowResizeTime]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();
        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);

    React.useEffect(() => {
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            draggable: isTouchDevice(),
            loop: products.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, products]);

    React.useEffect(() => {
        if (products && products.length > 0) {
            const newProductArray: ProductModel[] = [];
            const itreate = slidesToScroll;
            let nextItertor = itreate;
            newProductArray.push(products[0]);
            products.forEach((item, index) => {
                if (index === nextItertor) {
                    newProductArray.push(item);
                    nextItertor = nextItertor + itreate;
                }
            });
            setSildeProduct([...newProductArray]);
        }
    }, [products]);

    React.useEffect(() => {
        if(productInfos && products && products.length > 0 && !isLoadingState && !tracked && !initLoad){
            sendForTracking(products, productInfos);
        }
    }, [productInfos]);

    function sendForTracking(products: ProductModel[], productInfos:SafeDictionary<ProductInfo>){
        const firstId=products[0].id;
            if(session.isAuthenticated && !productInfos[firstId]?.failedToLoadPricing && productInfos[firstId]?.pricing){
                let realtimePricing: RealTimePricingModel= {
                    realTimePricingResults: [], uri: "",
                    properties: {}
                };
                products.forEach(prod => {
                    const price=productInfos[prod.id]?.pricing;
                    if(price) {
                        realtimePricing.realTimePricingResults?.push(price);
                    }
                });
                pushDataToDataLayer(products, fields.title, session, realtimePricing);
                setTracked(true);
            } else {
                pushDataToDataLayer(products, fields.title, session);
                setTracked(true);
            }
    }

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }

    const onClickDot = (i: number) => {
        if (embla) {
            embla.scrollTo(i);
            setSelectedIndex(i);
        }
    };

    const scrollPrev = () => {
        if (embla) {
            if (selectedIndex !== 0) {
                if (selectedIndex - 1 === 0) {
                    setCanScrollPrev(false);
                }
                else{
                    setCanScrollPrev(true);
                }
                setCanScrollNext(true);
                setSelectedIndex(prev => prev - 1);
                embla && embla.scrollPrev();
            }
        }
    };

    const scrollNext = () => {
        if (embla && slideProducts) {
            if (selectedIndex < slideProducts?.length - 1) {
                if (selectedIndex < slideProducts?.length - 1 && (selectedIndex + 1 === slideProducts?.length - 1)){
                    setCanScrollNext(false);
                }
                else {
                    setCanScrollNext(true);
                }
                setCanScrollPrev(true);
                setSelectedIndex(prev => prev + 1);
                embla && embla.scrollNext();
            }
        }
    };

    return (
        <>
            {filteredFields ? (
                <StyledWrapper
                    css={css`
                        margin-bottom: 50px;
                    `}
                >
                    <SkipNav
                        text={translate("Skip Carousel")}
                        extendedStyles={styles.skipCarouselButton}
                        destination={afterCarousel}
                    />
                    <StyledWrapper
                        css={css`
                            display: flex;
                            position: relative;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            margin-top: 10px;
                        `}
                    >
                        <Typography {...styles.titleText}>
                            {fields.title}
                        </Typography>
                        {link?.url ? (
                            <StyledWrapper>
                                <Link
                                    {...styles.urlText}
                                    href={link?.url}
                                    data-ga-promo={getGaTagforL1L2(fields.title, "", fields.showAll)}
                                >
                                    {fields.showAll || link?.title}
                                </Link>
                            </StyledWrapper>
                        ) : null}
                        <StyledWrapper
                            css={css`
                                position: absolute;
                                top: 8%;
                                right: 5%;
                                display: flex;
                                width: 68px;
                                justify-content: space-between;
                            `}
                        >
                            {products.length > slidesToScroll && (
                                <Button
                                    {...styles.prevArrowButton}
                                    onClick={() => scrollPrev()}
                                    disabled={!canScrollPrev}
                                    data-test-selector="prevBtn"
                                ></Button>
                            )}

                            {products.length > slidesToScroll && (
                                <Button
                                    {...styles.nextArrowButton}
                                    onClick={() => scrollNext()}
                                    disabled={!canScrollNext}
                                    data-test-selector="nextBtn"
                                ></Button>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>

                    <GridContainer
                        {...styles.mainContainer}
                        id="productCarousel_feature_best_sellers"
                        data-test-selector={`productCarousel_feature_best_sellers`}
                        data-ga-promo={getGaTagforL1L2(fields.title, "", "")}>
                        <GridItem {...styles.carouselGridItem}>
                            <StyledWrapper {...styles.carouselWrapper}>
                                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                    <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides" id="featureBestSellerCarousel">
                                        {products.map(product => (
                                            <StyledWrapper
                                                {...styles.carouselSlide}
                                                key={product.id}
                                                style={{ width: `calc(100% / ${slidesToScroll})` }}
                                            >
                                                <StyledWrapper
                                                    {...styles.carouselSlideInner}
                                                    id={`product_${product.id}`}
                                                    data-test-selector="productContainer"
                                                >
                                                    <ADIProductCarouselProduct
                                                        carouselId={id}
                                                        product={product}
                                                        showImage={true}
                                                        showBrand={true}
                                                        showTitle={true}
                                                        showPartNumbers={true}
                                                        showPrice={true}
                                                        showAddToCart={true}
                                                        showAddToList={true}
                                                        extendedStyles={styles.carouselProductStyles}
                                                        view={""}
                                                        showAvailability={false}
                                                        sourceName={fields.title}
                                                    />
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </GridItem>
                    </GridContainer>

                    
                    <span ref={afterCarousel} tabIndex={-1} />
                    <StyledWrapper {...styles.dotsContainerWrapper}>
                        {slideProducts &&
                            slideProducts.map((_, i) => {
                                const dotColorStyles =
                                    i === selectedIndex
                                        ? `
                            background:  ${ADIColors.darkBlue1};
                            &:hover { background-color: ${ADIColors.darkBlue1};
                                border: 1px solid ${ADIColors.darkBlue1}; }
                            &:active {background-color: ${ADIColors.darkBlue1};
                                border: 1px solid ${ADIColors.darkBlue1}; }
                        `
                                        : "";
                                const dotButtonStyles = {
                                    css: css`
                                        ${styles.dotButton?.css || ""}
                                        ${dotColorStyles}
                                    `,
                                };
                                // eslint-disable-next-line react/no-array-index-key
                                return <Button key={i} {...dotButtonStyles} onClick={() => onClickDot(i)} />;
                            })}
                    </StyledWrapper>
                </StyledWrapper>
            ) : null}
        </>
    );
};

const ADIFeaturedBestSellerCarousalWidget: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withIsInShell(withCategory(withTheme(ADIFeaturedBestSellerCarousal)))),
    definition: {
        group: "Basic",
        icon: "Carousel",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: fields.showAll,
                displayName: "URL Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: fields.showALLURL,
                displayName: "URL",
                sortOrder: 0,
                editorTemplate: "LinkField",
                fieldType: "General",
                defaultValue: {
                    value: "",
                    type: "Url",
                },
            },
            {
                name: fields.categoryName,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        name: { type, value },
                    } = item.fields;

                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                validate: (value, item) => {
                    const allCatIds = value.map(item => item.fields.name.value);
                    const allProductIds = value
                        .map(item => item.fields.productIds.map((item: any) => item.fields.id))
                        .filter((item: any) => new Set(item).size !== item.length);

                    if (new Set(allCatIds).size !== allCatIds.length) {
                        return "Category Already Exists";
                    } else if (allProductIds.length) {
                        return "Duplicate ProductId found in one of the Category";
                    } else {
                        return "";
                    }
                },
                fieldDefinitions: [
                    {
                        name: "name",
                        displayName: "Category Name",
                        sortOrder: 0,
                        editorTemplate: "LinkField",
                        isRequired: true,
                        defaultValue: {
                            value: "",
                            type: "Category",
                        },
                        allowUrls: item => {
                            return false;
                        },
                    },
                    {
                        name: fields.productIds,
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields) => {
                            return item.fields.id;
                        },
                        defaultValue: [],
                        sortOrder: 1,
                        fieldDefinitions: [
                            {
                                name: "id",
                                displayName: "Product Id",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: true,
                            },
                        ],
                    },
                ],
            },
            {
                name: fields.stackedOrCarousel,
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Stacked",
                        value: "Stacked",
                    },
                    {
                        displayName: "Carousel",
                        value: "Carousel",
                    },
                ],
                defaultValue: "Carousel",
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};
export default ADIFeaturedBestSellerCarousalWidget;
